import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { matchesApi } from 'src/app/shared/constants/api.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpBaseService } from '@evento-ng/libs';
import { TicketService } from 'src/app/shared/services/ticket.service';
@Component({
  selector: 'app-sport-booking',
  templateUrl: './sport-booking.component.html',
  styleUrls: ['./sport-booking.component.scss'],
})
export class SportBookingComponent {
  matchId: any;
  teamId: any;
  match: any;
  showCustomForm = false;
  showInfoForm = false;
  customFormDetails: any;
  showReview = false;
  showCartMobile = false;
  isMobile = false;
  invoice: any = null;
  isSport = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private ticketService: TicketService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.ticketService.bookTicket.next(null);
    this.route.queryParams.subscribe((res) => {
      this.matchId = res.matchId;
      this.teamId = res.teamId;
    });
    this.isSport = this.router.url.includes('sport');
  }

  ngOnInit() {
    this.getMatchDetails();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  setCartMobile(value) {
    this.showCartMobile = value;
  }

  getMatchDetails() {
    this.spinner.show();
    this.dataService.get(`${matchesApi}/${this.matchId}`).subscribe((res) => {
      this.spinner.hide();
      this.match = res;
    });
  }

  goToCustomForm(event) {
    this.customFormDetails = event;
    this.showCustomForm = true;
  }

  goToInfoForm() {
    this.showCustomForm = false;
    this.showInfoForm = true;
  }

  goToReview() {
    this.showCustomForm = false;
    this.showInfoForm = false;
    this.showReview = true;
  }
  updateTeamId(newTeamId: any) {
    this.teamId = newTeamId;
    if (newTeamId) {
      this.getMatchDetails();
    }
  }
}
